export default {
  heroEyebrow: "Hub de recursos Basetao Spreadsheet",
  heroH1: "Basetao Spreadsheet — Encontre produtos, vendedores e recursos de compra mais inteligentes",
  heroText:
    "Descubra recursos de Basetao Spreadsheet, guias de pesquisa de produtos, informações de vendedores, dicas de controle de qualidade, guias de envio e recursos práticos para facilitar a pesquisa de compras na China.",
  heroCta1: "Basetao Spreadsheet",
  heroCta2: "Comprar agora",
  heroTrust: "Recurso independente · Pesquisa prática · Guias atualizados",

  categoriesEyebrow: "Compre por categoria",
  categoriesTitle: "Explore produtos por categoria",
  categoriesText:
    "Escolha uma categoria abaixo para explorar produtos, vendedores e achados do spreadsheet no site principal. Cada link abre em uma nova aba.",
  dropdownLabel: "Selecionar uma categoria",
  dropdownPlaceholder: "Escolha uma categoria…",
  dropdownGo: "Abrir",

  aboutEyebrow: "O que é",
  aboutTitle: "O que é um Basetao Spreadsheet?",
  aboutP1:
    "Um Basetao Spreadsheet é uma lista ou tabela compartilhada pela comunidade com produtos, links, notas de vendedores e observações de controle de qualidade (QC) usadas por compradores que fazem pedidos pelo agente Basetao. Essas planilhas ajudam você a comparar achados, identificar vendedores confiáveis e pesquisar itens antes de comprar.",
  aboutP2:
    "Como uma planilha organiza centenas de links de produtos em um só lugar, ela transforma uma busca lenta e dispersa em uma forma mais rápida e estruturada de pesquisar roupas, tênis, acessórios e muito mais.",
  aboutP3:
    "Trate sempre uma planilha como ponto de partida, não como garantia. Verifique você mesmo o preço atual, a avaliação do vendedor e as condições de envio antes de fazer o pedido.",

  guidesEyebrow: "Guias e artigos",
  guidesTitle: "Leia nossos guias originais",
  guidesText:
    "Artigos independentes e originais para ajudar você a pesquisar produtos, entender o QC e tomar decisões melhores.",
  guide1Title: "Basetao Spreadsheet: guia completo para iniciantes",
  guide1Text:
    "O que é um Basetao Spreadsheet, como funciona, categorias populares, dicas de QC e o básico de envio — tudo o que um iniciante precisa saber.",
  guide2Title: "Visão geral das categorias de produtos",
  guide2Text:
    "Um passeio rápido pelas principais categorias, de tênis e moletons a bolsas e acessórios.",
  guide3Title: "Como ler fotos de QC",
  guide3Text:
    "Entenda fotos de QC, medidas e os sinais de alerta que você deve verificar antes de aprovar um item.",
  guide4Title: "O básico de envio",
  guide4Text:
    "Como o custo de envio é estimado, o que influencia o preço e os fatores a comparar entre as linhas.",
  readMore: "Ler artigo",

  howEyebrow: "Como funciona",
  howTitle: "Pesquise melhor em quatro passos",
  step1Title: "Encontre",
  step1Text: "Descubra produtos, vendedores e recursos em um só lugar.",
  step2Title: "Pesquise",
  step2Text: "Compare informações de produtos, vendedores e controle de qualidade.",
  step3Title: "Verifique",
  step3Text: "Verifique você mesmo o preço, o envio e as políticas.",
  step4Title: "Decida",
  step4Text: "Faça o pedido com mais informação e menos surpresas.",

  faqEyebrow: "FAQ",
  faqTitle: "Perguntas frequentes",
  faq1Q: "O que é um Basetao Spreadsheet?",
  faq1A:
    "É uma lista ou tabela compartilhada pela comunidade com links de produtos, notas de vendedores e observações de QC, usada por compradores que fazem pedidos pelo agente Basetao.",
  faq2Q: "Este é o site oficial da Basetao?",
  faq2A:
    "Não. Este é um site informativo independente, não afiliado nem endossado pela Basetao.",
  faq3Q: "Como encontro produtos no site principal?",
  faq3A:
    "Use o menu suspenso ou os botões de categoria desta página. Cada link abre a categoria correspondente no site principal em uma nova aba.",
  faq4Q: "Quanto custa o envio da Basetao?",
  faq4A:
    "O custo depende do destino, do peso, das dimensões e do método de envio. Verifique sempre as tarifas atuais no site principal antes de fazer o pedido.",
  faq5Q: "Os produtos são garantidos?",
  faq5A:
    "Não. Uma planilha ou um link de produto não garante autenticidade, qualidade nem entrega. Pesquise sempre primeiro os vendedores e as informações de QC.",

  finalCtaTitle: "Comece com o Basetao Spreadsheet",
  finalCtaText:
    "Explore recursos de produtos, guias de pesquisa, informações de QC e guias de envio em um hub organizado.",
  finalCtaButton: "Explorar Basetao Spreadsheet",
};